export const categories = [
  { slug: 'rexiao', name: '热门推荐', icon: 'ri-fire-line' },
  { slug: 'lianai', name: '恋爱言情', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻冒险', icon: 'ri-rocket-line' },
  { slug: 'dongzuo', name: '动作热血', icon: 'ri-flashlight-line' },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-search-eye-line' },
  { slug: 'gaoxiao', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'danmei', name: '耽美BL', icon: 'ri-star-line' },
  { slug: 'kongbu', name: '恐怖惊悚', icon: 'ri-ghost-line' },
];

export const categoryMap: Record<string, string> = {
  rexiao: '热门推荐',
  lianai: '恋爱言情',
  qihuan: '奇幻冒险',
  dongzuo: '动作热血',
  xuanyi: '悬疑推理',
  gaoxiao: '搞笑日常',
  danmei: '耽美BL',
  kongbu: '恐怖惊悚',
};